import { send_cr_request } from "../store/reducers/AppReducer";
import { apis } from "./API";

export default class Global {
  public classes_filtered: any = [];
  public brand_color: any = "#bd1e2c";

  public set_brand_color(brand_color: any) {
    this.brand_color = brand_color;
  }

  public get_brand_color() {
    return this.brand_color;
  }
}

export const format_object_for_terminal = (object: string) => {
  return object
    .replace(/\{/g, "??")
    .replace(/ /g, "!#!")
    .replace(/\"/g, "#%#")
    .replace(/\'/g, "'''")
    .replace(/\}/g, "!!")
    .replace(/\(/g, "#!%")
    .replace(/\)/g, "$#")
    .replace(/\[/g, "%$%")
    .replace(/\]/g, "$%$");
};

export const StatusCode = {
  LOADING: "loading",
  IDLE: "idle",
  ERROR: "error",
  SAVING: "saving",
  SUCCESS: "success",
};

export const set_dimensions = (can_shrink_lead_form: Boolean = false) => {
  return {
    mobile: can_shrink_lead_form || window.innerWidth < 950 ? true : false,
    tablet: window.innerWidth < 950 ? true : false, //ignore
    desktop: window.innerWidth >= 950 && !can_shrink_lead_form ? true : false,
  };
};

export const style_calendar = () => {
  var dimensions = set_dimensions();
  const isTablet = window.innerWidth >= 768;

  if (dimensions.desktop) {
    return "Calendar";
  } else {
    if (dimensions.mobile && !isTablet) {
      return "MobileCalendar";
    } else {
      return "TabletCalendar";
    }
  }
};

export const isTablet = () => {
  return window.innerWidth > 430;
};

export const style_time_slots = () => {
  setInterval(() => {
    var list: any = document.getElementById("slots");
    if (list) {
      if (window.innerHeight >= 1366) {
        list.style.maxHeight = "520px";
      } else if (window.innerHeight >= 1180) {
        list.style.maxHeight = "350px";
      } else if (window.innerHeight >= 910) {
        list.style.maxHeight = "250px";
      } else if (window.innerHeight >= 896) {
        list.style.maxHeight = "220px";
      } else if (window.innerHeight >= 844) {
        list.style.maxHeight = "200px";
      } else if (window.innerHeight < 740) {
        list.style.maxHeight = "50px";
      } else if (window.innerHeight >= 740) {
        list.style.maxHeight = "120px";
      }
    }
  });
};